import { NextPage } from 'next'
import { useState, useEffect } from 'react'
import Head from 'next/head'
import { useTranslation } from 'react-i18next'
import Footer from '~/components/Footer'
import Header from '~/components/Header'
import { useOneOfModalOpened } from '~/state/application/hooks'
import { ApplicationModal } from '~/state/application/reducer'
import AdBanner from '../AdBanner'
import { WaterMark } from '../WaterMark'
import { WrapETHForm } from '../WETH'
import { OrderList, OrderPreview, OrderStatus, LimitSwap } from './components'
import {
  StyledContainer,
  StyledMainWrapper,
  StyledFormsWrapper,
} from './styled'
import { useBreakpoint, useIsValidWETHNetwork } from '~/hooks'
import dynamic from 'next/dynamic'
const SwapPriceChart = dynamic(
  () => import('~/components/charts/SwapPriceChart'),
  {
    ssr: false,
  },
)
const MiniSwapPriceChart = dynamic(
  () => import('~/components/charts/MiniSwapPriceChart'),
  {
    ssr: false,
  },
)

const LimitOrder: NextPage = () => {
  const { t } = useTranslation()
  const { isMobile } = useBreakpoint()
  const wethWrapOpened = useOneOfModalOpened([
    ApplicationModal.WETH_WRAP,
    ApplicationModal.WETH_PREVIEW,
    ApplicationModal.WETH_RESULT,
  ])
  const isValidWETHNetwork = useIsValidWETHNetwork()
  const [miniChartVisible, setMiniChartVisible] = useState<boolean>(false)
  const handleChartExpand = () => {
    setMiniChartVisible(!miniChartVisible)
  }

  const RenderChart = () =>
    miniChartVisible ? (
      <MiniSwapPriceChart handleChartExpand={handleChartExpand} />
    ) : (
      <SwapPriceChart handleChartExpand={handleChartExpand} />
    )

  useEffect(() => {
    if (isMobile)
      return () => {
        setMiniChartVisible(true)
      }
  }, [])

  return (
    <>
      <Head>
        <title>{t('meta_limit_order_title')}</title>
        <meta name="description" content={t('meta_limit_order_description')} />
        <meta name="keywords" content={t('meta_limit_order_keywords')} />
      </Head>
      <StyledContainer>
        <Header />
        <StyledMainWrapper>
          {(!isMobile || wethWrapOpened) && <RenderChart />}
          <StyledFormsWrapper>
            {!wethWrapOpened && (
              <div>
                <LimitSwap />
                <OrderPreview />
                <OrderStatus />
                {isMobile && <RenderChart />}
                <OrderList />
                <WaterMark />
              </div>
            )}
            {isValidWETHNetwork && wethWrapOpened && <WrapETHForm />}
          </StyledFormsWrapper>
        </StyledMainWrapper>
        <AdBanner />
        <Footer />
      </StyledContainer>
    </>
  )
}

export default LimitOrder
